import { ProductPageSectionParams, ProductPageSectionType } from "../access/productPageSection/types";

export class ProductPageSection {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  procedureInstanceId: string;
  title: string;
  description: string;
  position: number;
  parentId: string;
  type: ProductPageSectionType;

  constructor(params: ProductPageSectionParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.procedureInstanceId = params.procedureInstanceId;
    this.parentId = params.procedureInstanceId;
    this.title = params.title;
    this.description = params.description || '';
    this.position = params.position;
    this.type = params.type;
  }
}
